module.exports = __webpack_public_path__ + "img/marisa kirisame_sc1.215ead36.png";